module.exports = __webpack_public_path__ + "static/media/matilde-hat-sri-lanka-thinking.6c2921b4.png";